import { useState } from "react";
import { motion } from "framer-motion";
import { Dialog, DialogContent } from "@/components/ui/dialog";

const PHOTOS = [
  {
    src: "https://customer-assets-agu9un31.emergentagent.net/job_2e5c0fe7-21bd-4845-ae98-db1e0d67887b/artifacts/4372cda16a7216ce_barb.webp",
    alt: "Sala principale con logo MB arancione e poltrone in pelle nera",
    label: "La Sala",
    testid: "gallery-image-main-hall",
    span: "sm:col-span-2 sm:row-span-2",
  },
  {
    src: "https://customer-assets-agu9un31.emergentagent.net/job_2e5c0fe7-21bd-4845-ae98-db1e0d67887b/artifacts/91789042a3e0e8eb_barberia.webp",
    alt: "Ingresso con muro in pietra e cuore anatomico decorativo",
    label: "L'Ingresso",
    testid: "gallery-image-entrance",
    span: "",
  },
  {
    src: "https://customer-assets-agu9un31.emergentagent.net/job_2e5c0fe7-21bd-4845-ae98-db1e0d67887b/artifacts/4cdd9c74e727eab1_barber.webp",
    alt: "Poltrona vicino all'ingresso con barber pole e luce serale",
    label: "La Sera",
    testid: "gallery-image-evening",
    span: "",
  },
];

export function Gallery() {
  const [open, setOpen] = useState(null);

  return (
    <section id="galleria" className="relative py-24 sm:py-36">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
        >
          <p className="text-xs font-mono tracking-[0.3em] uppercase text-ember">Il Locale</p>
          <h2 className="mt-4 font-serif font-bold tracking-tight text-3xl sm:text-4xl lg:text-5xl text-ivory max-w-2xl">
            Legno di noce, pietra d'Atri, <span className="italic text-ember">pelle nera.</span>
          </h2>
        </motion.div>

        <div className="mt-14 grid sm:grid-cols-3 auto-rows-[240px] sm:auto-rows-[260px] gap-4">
          {PHOTOS.map((p, i) => (
            <motion.button
              key={p.testid}
              data-testid={p.testid}
              onClick={() => setOpen(p)}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.9, delay: i * 0.12, ease: [0.16, 1, 0.3, 1] }}
              className={`group relative overflow-hidden rounded-lg border border-white/10 text-left ${p.span}`}
            >
              <img
                src={p.src}
                alt={p.alt}
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-[1.4s] ease-out"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-void/80 via-transparent to-transparent opacity-80 group-hover:opacity-100 transition-opacity duration-500" />
              <span className="absolute bottom-4 left-4 text-xs font-mono uppercase tracking-[0.25em] text-ivory">
                {p.label}
              </span>
              <span className="absolute top-4 right-4 w-8 h-8 rounded-full bg-void/50 backdrop-blur border border-white/20 flex items-center justify-center text-ivory opacity-0 group-hover:opacity-100 transition-opacity duration-300 text-sm">
                +
              </span>
            </motion.button>
          ))}
        </div>
      </div>

      <Dialog open={!!open} onOpenChange={() => setOpen(null)}>
        <DialogContent className="bg-void border-white/10 max-w-3xl p-2" data-testid="gallery-lightbox">
          {open && <img src={open.src} alt={open.alt} className="w-full h-auto rounded-md" />}
        </DialogContent>
      </Dialog>
    </section>
  );
}
